module.exports = __webpack_public_path__ + "static/media/file-audio.8b296ee5.svg";